import type { EasidResponse } from 'owa-licensing-utils/lib/schema/EasidResponse';
import type { CoprincipalAccountSource } from 'owa-account-source-list-store';

export interface PremiumStatus {
    premiumStatusBit: boolean | undefined;
}

export enum DialogState {
    LOADING_EASID_STATUS,
    EASID_FOUND,
    LINKING,
    LINK_SUCCESS,
    LINK_ERROR,
    UNLINK,
    UNLINKING,
    UNLINK_SUCCESS,
    UNLINK_ERROR,
    EASID_NOT_FOUND,
    SERVICE_ERROR_ON_GET,
    CLOSED,
}

export interface EasidLinkStore {
    entries: Map<string, EasidResponse>;
    premiumEntries: Map<string, PremiumStatus>;
    dialogState: DialogState;
    accountToLink: CoprincipalAccountSource | undefined;
}
